import { HttpCookieService } from 'src/app/services/general/http-cookie.service';
import { AUTH_COOKIE_CSRF_TOKEN } from 'src/app/utils/constants/authentication/authentication.constants';

/**
 * Sends a POST the browser keeps alive after the page closes, with the same cookie and
 * CSRF header the HTTP interceptor adds. Sent once, without the interceptor's retries.
 * Resolves with the response, or null if the request failed.
 *
 * HttpClient requests are cancelled when the page unloads, and sendBeacon can't set the
 * CSRF header, so a keepalive fetch is used instead.
 */
export function sendKeepalivePost(url: string): Promise<Response | null> {
  const csrfToken = new HttpCookieService().getCookie(AUTH_COOKIE_CSRF_TOKEN);
  const headers: Record<string, string> = csrfToken ? { 'X-CSRF-Token': csrfToken } : {};
  return fetch(url, { method: 'POST', keepalive: true, credentials: 'include', headers })
    .then((res) => (res.ok ? res : null))
    .catch(() => null);
}
